import {Injectable} from '@angular/core';

@Injectable({
				providedIn: 'root'
			})
export class UiNumberFormatterService {

	minsToClock(mins: number) {
		const h = (mins / 60).toFixed(2)
							 .split('.')[0].padStart(2, '0')
		const m = (mins % 60).toFixed(0)
							 .padStart(2, '0')
		return `${h}:${m}`
	}
}
